import React from 'react'
import { Link } from 'react-router-dom'
import Icons from '../myIcon/Icons'

export default function DefaultButton({text, to , color=false, onClick, disabled}) {
  return (
    <>
      <Link disabled={disabled} onClick={onClick} to={to} className={color? "default-btn color-btn" : 'default-btn'}>
     {text}
      <Icons name="Longarrow_right"/>
      </Link>
    </>
  )
}
